module.exports = __webpack_public_path__ + "media/images/pages/peel/clean-7d55f2e20b85216251b5916203c58950.svg";